import types from '../../../actions/types';

export function loginAction(data, resolve, reject) {
    return {
        type: types.LOGIN.REQUEST, payload: {data, resolve, reject}
    };
}



// WEBPACK FOOTER //
// ./src/js/routes/login/modules/login-actions.js